export const APP_ROUTES = {
    home: '/',
    auth: '/auth',
    dashboard: '/dashboard',
    inbox: '/inbox',
    edit: '/edit',
    preview: '/preview',
} as const

export const PROTECTED_ROUTE_PREFIXES = [
    APP_ROUTES.dashboard,
    APP_ROUTES.edit,
    APP_ROUTES.preview,
    APP_ROUTES.inbox,
] as const
